import React from 'react';
import LightGreenButton from '../Buttons/LightGreenButton';
import GreenButton from '../Buttons/GreenButton';
import FilterBySixMonths from './Components/FilterBySixMonths';
import {Form, Formik} from 'formik';
import {scrollToTop, submitFilterFieldCleaner} from '../../assets/utils/utils';
import {useTranslation} from 'react-i18next';
import {RequestOrdersListType} from '../../types/TypesStore';
import {validationFilterForm} from '../../assets/utils/validation';
import FilterByStatus from './Components/FilterByStatus';
import TextFilterField from './Components/TextFilterField';

type Props = {
	active: boolean;
	setActive: (active: boolean) => void;
	setFilters: (filters: RequestOrdersListType) => void;
};
const ListInvoicesFilter: React.FC<Props> = ({
	active,
	setActive,
	setFilters,
}) => {
	const {t} = useTranslation();
	const initialValues: RequestOrdersListType = {
		month: '',
		product_name: '',
		order_id: '',
		status: '',
		filter_active: 0,
	};
	const handleSubmit = (values: RequestOrdersListType) => {
		const filteredValues = submitFilterFieldCleaner(values);
		setFilters({...filteredValues, filter_active: 1});
		setActive(false);
		scrollToTop('smooth');
	};
	const statusOptions = [
		{
			value: 'null',
			label: t('Всі'),
		},
		{
			value: 'created',
			label: t('Чернетка'),
		},
		{
			value: 'confirmed',
			label: t('Нові'),
		},
		{
			value: 'rejected',
			label: t('Відхилені'),
		},
		{
			value: 'approved',
			label: t('Підтверджено'),
		},
		{
			value: 'packaged',
			label: t('Запаковані'),
		},
		{
			value: 'shipped',
			label: t('Відправлені'),
		},
		{
			value: 'receive',
			label: t('Отримані'),
		},
	];
	return (
		<div
			className={`filter-team__filter-item item-filter ${!active ? '' : 'active'}`}
		>
			<div className="item-filter__wrapper">
				<Formik
					enableReinitialize
					validationSchema={validationFilterForm}
					initialValues={initialValues}
					onSubmit={handleSubmit}
				>
					{({
						values,
						errors,
						touched,
						handleSubmit,
						//status,
						setFieldValue,
						resetForm,
					}) => {
						return (
							<Form onSubmit={handleSubmit}>
								<FilterBySixMonths setFieldValue={setFieldValue} />
								<FilterByStatus
									fieldName={'status'}
									statusOptions={statusOptions}
									label={t('Статус доставки')}
									value={values.status ?? ''}
								/>
								<TextFilterField
									label={t('За товаром')}
									fieldName={'product_name'}
									placeholder={t('Комплекс Омега')}
									value={values.product_name ?? ''}
								/>
								<TextFilterField
									label={t('За номером')}
									fieldName={'order_id'}
									placeholder={t('Введіть номер')}
									value={values.order_id ?? ''}
									touched={touched.order_id !== undefined}
									error={errors.order_id !== undefined}
								/>

								<div className="item-filter__buttons">
									<LightGreenButton text={t('застосувати')} type={'submit'} />
									<GreenButton
										text={t('скасувати фільтр')}
										type={'button'}
										onClick={() => {
											setFilters({filter_active: 0, offset: 0});
											resetForm();
										}}
									/>
								</div>
							</Form>
						);
					}}
				</Formik>
			</div>
		</div>
	);
};

export default ListInvoicesFilter;
